module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7o6rJ"))).then(() => parcelRequire('d0iPb'));